/* Palcard hover media: images crossfade via CSS; this drives video —
   hosted play while hovered, external iframes sized to cover and
   autoplaying on first hover. Delegated + self-guarding so
   AJAX-rendered cards work without re-init. */
(function () {
  if (window.__palcardHover) return;
  window.__palcardHover = true;

  // Alt media is hidden below the desktop breakpoint, same as the hover lift.
  var desktop = window.matchMedia('(min-width: 749px)');

  function altMedia(card) {
    return card.querySelector('.palcard__media-alt');
  }

  function start(card) {
    if (!desktop.matches) return;
    var media = altMedia(card);
    if (!media) return;
    if (media.tagName === 'IFRAME') {
      // object-fit doesn't apply to iframes: size the embed to cover the
      // media box (crop like object-fit: cover) using the media aspect Liquid
      // passed via data-width/data-height. Falls back to box size.
      var box = card.querySelector('.palcard__media');
      var vw = parseFloat(media.dataset.width);
      var vh = parseFloat(media.dataset.height);
      if (box && vw > 0 && vh > 0) {
        var rect = box.getBoundingClientRect();
        var scale = Math.max(rect.width / vw, rect.height / vh);
        media.style.width = Math.ceil(vw * scale) + 'px';
        media.style.height = Math.ceil(vh * scale) + 'px';
      }
      if (media.dataset.src && !media.getAttribute('src')) {
        media.src = media.dataset.src;
      }
    } else if (media.tagName === 'VIDEO') {
      var played = media.play();
      if (played && typeof played.catch === 'function') played.catch(function () {});
    }
  }

  function stop(card) {
    var media = altMedia(card);
    if (!media) return;
    if (media.tagName === 'IFRAME') {
      media.removeAttribute('src');
    } else if (media.tagName === 'VIDEO') {
      media.pause();
      try { media.currentTime = 0; } catch (e) {}
    }
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest('.palcard');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    start(card);
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('.palcard');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    stop(card);
  });
})();
